import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectIsWebview } from '../../selectors/page';

import { ApplicationContext } from '../applicationContext';

/**
 * Если страница открыта НЕ в вебвью - всегда показывает кнопку "копировать"
 */
export function useIsClipboardVisible() {
  const { config } = useContext(ApplicationContext);
  const isWebview = useSelector(selectIsWebview);

  const result = useMemo<boolean>(() => {
    if (!isWebview) {
      return true;
    }

    return Boolean(config.get<boolean>('valuationForAgent.clipboardWebviewVisible'));
  }, [config, isWebview]);

  return result;
}
